var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnpaidIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-wallet--money-payment-finance-wallet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.7143 16.5715V12.2857C25.7143 11.7174 25.4885 11.1724 25.0867 10.7705C24.6848 10.3686 24.1398 10.1429 23.5714 10.1429H3.2143C2.64598 10.1429 2.10093 10.3686 1.69907 10.7705C1.29721 11.1724 1.07144 11.7174 1.07144 12.2857V27.2857C1.07144 27.8541 1.29721 28.3991 1.69907 28.801C2.10093 29.2028 2.64598 29.4286 3.2143 29.4286H23.5714C24.1398 29.4286 24.6848 29.2028 25.0867 28.801C25.4885 28.3991 25.7143 27.8541 25.7143 27.2857V21.9286",
    stroke: "#A33270",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.22858 4.78573L20.3786 1.6143C20.5151 1.57583 20.658 1.56543 20.7987 1.58371C20.9393 1.60199 21.0748 1.64859 21.197 1.72068C21.3192 1.79278 21.4254 1.88887 21.5094 2.00318C21.5934 2.11748 21.6534 2.24761 21.6857 2.38573L22.2857 4.78573",
    stroke: "#A33270",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.8572 16.5715H22.5C21.9083 16.5715 21.4286 17.0512 21.4286 17.6429V20.8572C21.4286 21.4489 21.9083 21.9286 22.5 21.9286H27.8572C28.4489 21.9286 28.9286 21.4489 28.9286 20.8572V17.6429C28.9286 17.0512 28.4489 16.5715 27.8572 16.5715Z",
    stroke: "#A33270",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpaidIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unpaid_icon.fbbd31ef7fc38f3279d5fc44915be4ec.svg";